import React from 'react';
import {Box, Button, Typography} from '@mui/material';
import {themeColors} from '../theme/Theme';
import SaltusThemeProvider from '../contexts/ThemeProvider';

const classes = {
  overlay: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'absolute',
  },
  root: {
    color: '#FFFFFF',
    background: themeColors.backgroundDark,
    padding: '20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headline: {
    fontWeight: 'normal',
    lineHeight: 'inherit',
    margin: 0,
    padding: 0,
    color: 'white',
  },
  button: {
    backgroundColor: themeColors.coral,
    marginTop: '0.5rem',
  },
};

interface OfflineProps {
  text: string;
}

export const OfflinePage = (props: OfflineProps) => {
  const {text} = props;

  return (
    <SaltusThemeProvider>
      <Box
        data-testid="Offline message display"
        sx={{...classes.root, ...classes.overlay}}
      >
        <img
          style={{
            width: '100px',
            height: '25px',
            objectFit: 'contain',
          }}
          alt="company logo"
          src="/logo.svg"
        />
        <Box mt={2}>
          <div
            style={{
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'row',
              textAlign: 'center',
              lineHeight: '49px',
              alignItems: 'center',
            }}
          >
            <Typography variant="h4" sx={classes.headline}>
              {text}
            </Typography>
          </div>
          <Button
            sx={classes.button}
            variant="contained"
            color="secondary"
            href="/"
            data-testid="Log in button"
          >
            Log in
          </Button>
        </Box>
      </Box>
    </SaltusThemeProvider>
  );
};
